import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: '12px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
    overflow: 'hidden',
    marginBottom: '12px',
    display: 'flex',
  },
  rootFirst: {
    borderRadius: '12px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
    overflow: 'hidden',
    marginBottom: '16px',
  },
  imageContainerFirst: {
    height: '200px',
    overflow: 'hidden',
    position: 'relative',
    '& span': {
      width: '100%',
      position: 'absolute',
      top: '50%',
      left: 0,
      transform: 'translate(0, -50%)',
    },
  },
  imageContainer: {
    flexShrink: 0,
    width: '110px',
    overflow: 'hidden',
    '& span': {
      width: '100%',
      height: '100%',
    },
  },
  details: {
    padding: '12px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  detailsFirst: {
    padding: '14px 16px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
}));

export default function CampaignSkeleton({ mode = 'list' }) {
  const classes = useStyles();

  return (
    <div className={mode == 'list' ? classes.root : classes.rootFirst}>
      <div className={mode == 'list' ? classes.imageContainer : classes.imageContainerFirst}>
        <Skeleton variant="rect" height={mode == 'list' ? '100%' : 220} style={{ minHeight: mode == 'list' ? 80 : 220 }} />
      </div>
      <div className={mode == 'list' ? classes.details : classes.detailsFirst}>
        <Skeleton variant="rect" height={16} width="40%" />
        <Skeleton variant="rect" height={20} width="90%" />
        <Skeleton variant="rect" height={14} width="70%" />
        <Skeleton variant="rect" height={16} width="50%" />
      </div>
    </div>
  );
}
